import script from "./AutocompletePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutocompletePopup.vue?vue&type=script&setup=true&lang=ts"

import "./AutocompletePopup.vue?vue&type=style&index=0&id=2402e0bc&lang=css"

const __exports__ = script;

export default __exports__